export const removeOutOfStockVariants = (
  variants,
  outOfStockVariantIds,
  shopOversell,
) => {
  const newVariantsIds = {};
  Object.keys(variants).forEach((variantId) => {
    if (
      !outOfStockVariantIds?.includes(variantId) ||
      shopOversell === 'ALLOW'
    ) {
      newVariantsIds[variantId] = variants[variantId];
    }
  });
  return newVariantsIds;
};
